/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_PlatformInputs */

const en_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const fr_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plate-forme`)
};

const de_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform`)
};

const it_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piattaforma`)
};

const ru_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа`)
};

const es_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataforma`)
};

const zh_cn2_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

const ja_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム`)
};

const hi_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लैटफ़ॉर्म`)
};

const pt_pt2_live_caption_platform = /** @type {(inputs: Live_Caption_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataforma`)
};

/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Live_Caption_PlatformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_platform = /** @type {((inputs?: Live_Caption_PlatformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_PlatformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_platform(inputs)
	if (locale === "de") return de_live_caption_platform(inputs)
	if (locale === "it") return it_live_caption_platform(inputs)
	if (locale === "ru") return ru_live_caption_platform(inputs)
	if (locale === "es") return es_live_caption_platform(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_platform(inputs)
	if (locale === "ja") return ja_live_caption_platform(inputs)
	if (locale === "hi") return hi_live_caption_platform(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_platform(inputs)
	return en_live_caption_platform(inputs)
});